import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getLeave(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEELEAVEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getUserWiseDetails(userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETUSERBYDEATILSBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function leaveApprove(
  userId: string,
  id: string,
  status: any
) {
  const body = {
    userId: userId,
    id: id,
    status: status,
  };
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.LEAVEAPPROVE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

